import { experience } from "../utils/experience";
import Chip from "./chip";
import Subtitle from "./subtitle";
import BottomLine from "./bottomLine";

function ExperienceCard({ company, context, role, period, activities, skills }) {
  return (
    <div className="w-full p-6 border-2 border-black hover:shadow-xl transition ease-out duration-500">
      <div className="flex flex-col justify-between gap-1 pb-4 border-b border-slate-200 md:flex-row md:items-end">
        <div>
          <h3 className="text-slate-900 font-semibold font-serif text-xl">
            {role}
          </h3>
          <p className="text-slate-800 font-mono text-sm">
            {company}
            {context ? ` · ${context}` : ""}
          </p>
        </div>
        <p className="text-emerald-600 font-mono text-sm font-medium whitespace-nowrap">
          {period}
        </p>
      </div>

      <ul className="py-4 flex flex-col gap-2">
        {activities.map((activity, index) => (
          <li
            key={index}
            className="pl-4 relative text-slate-800 font-mono text-sm leading-6 before:content-['—'] before:absolute before:left-0 before:text-emerald-500"
          >
            {activity}
          </li>
        ))}
      </ul>

      <div className="flex flex-wrap gap-2 pt-2">
        {skills.map((skill, index) => (
          <Chip key={index} text={skill} />
        ))}
      </div>
    </div>
  );
}

export default function Experience() {
  return (
    <div className="w-[90%] h-full py-12 flex flex-col justify-center items-center md:w-[75%] lg:w-[65%]">
      <Subtitle text="Experience" className="text-3xl md:text-5xl" />
      <BottomLine />
      <div className="w-full flex flex-col gap-6 mt-6">
        {experience.map((exp, index) => (
          <ExperienceCard key={index} {...exp} />
        ))}
      </div>
    </div>
  );
}
